// Regex patterns for QR code parsing
// Pattern for format: "attendeeId-eventId" (ex: "123-456")
const QR_CODE_FORMAT_PATTERN = /^(\d+)-(\d+)$/;

// Pattern for URL parameters: "attendee_id=123" or "attendee-id=123" (case insensitive)
const URL_PARAM_PATTERN = /attendee[_-]?id=(\d+)/i;

// Pattern for attendee format: "attendee-123" (case insensitive)
const ATTENDEE_FORMAT_PATTERN = /attendee-(\d+)/i;


export const extractAttendeeIdFromQR = (qrResult) => {
  try {
    // Try QR code format: "attendeeId-eventId"
    const qrMatch = qrResult.match(QR_CODE_FORMAT_PATTERN);
    if (qrMatch) {
      const attendeeId = parseInt(qrMatch[1]);
      return attendeeId;
    }
    
    // Try direct numeric value
    if (!isNaN(qrResult)) {
      return parseInt(qrResult);
    }
    
    // Try JSON format with attendee_id or id field
    try {
      const parsed = JSON.parse(qrResult);
      if (parsed.attendee_id || parsed.id) {
        return parsed.attendee_id || parsed.id;
      }
    } catch (e) {
      // Not valid JSON, continue to next pattern
    }
    
    // Try URL parameter format: "attendee_id=123" or "attendee-id=123"
    const urlMatch = qrResult.match(URL_PARAM_PATTERN);
    if (urlMatch) {
      return parseInt(urlMatch[1]);
    }
    
    // Try attendee format: "attendee-123"
    const attendeeMatch = qrResult.match(ATTENDEE_FORMAT_PATTERN);
    if (attendeeMatch) {
      return parseInt(attendeeMatch[1]);
    }

    return null;
  } catch (error) {
    return null;
  }
};

export const extractEventIdFromQR = (qrResult) => {
  try {
    // Try QR code format: "attendeeId-eventId"
    const qrMatch = qrResult.match(QR_CODE_FORMAT_PATTERN);
    if (qrMatch) {
      const eventId = parseInt(qrMatch[2]);
      return eventId;
    }

    // Try JSON format with event_id field
    try {
      const parsed = JSON.parse(qrResult);
      if (parsed.event_id) {
        return parsed.event_id;
      }
    } catch (e) {
      // Not valid JSON
    }

    return null;
  } catch (error) {
    return null;
  }
};
